import type { IHubCatalog, IHubPackage } from "@models";

/** Resolve the catalog entry that matches a hub package (name, label, version). */
export function findHubCatalogForPackage(
  catalogs: IHubCatalog[],
  pkg: IHubPackage,
): IHubCatalog | undefined {
  if (!catalogs.length) return undefined;
  const relation = pkg.catalogRelations?.[0];
  if (!relation) return undefined;
  return catalogs.find(
    (c) =>
      c.catalogId === relation.catalogId &&
      c.version === relation.catalogVersion,
  );
}

function findHubPackageMatchingCatalog(
  packages: IHubPackage[] | undefined,
  catalog: IHubCatalog,
): IHubPackage | undefined {
  if (!packages?.length) return undefined;
  return packages.find((p) => {
    const relation = p.catalogRelations?.[0];
    return (
      relation?.catalogId === catalog.catalogId &&
      relation?.catalogVersion === catalog.version
    );
  });
}

export function getHubCartPackageIdForCatalog(
  packages: IHubPackage[] | undefined,
  catalog: IHubCatalog,
): number | undefined {
  const m = findHubPackageMatchingCatalog(packages, catalog);
  return m?.packageId != null && m.packageId > 0 ? m.packageId : undefined;
}
